'use client'
import React from 'react'
import Image from 'next/image'
import NewsSideItem from '@/components/news/NewsSideItem'
import { useGetMostNewedNewsQuery } from '@/redux/services/newsApi'
import StatsComponent from '../StatsComponent'
import Link from 'next/link'
import NewsDate from './NewsDate'
import s from './NewsBanner.module.scss'
import classNames from 'classnames'

interface NewsBannerUisngNewestNewsProps {
    lightTheme?: boolean
}

const NewsBannerUisngNewestNews = ({ lightTheme }: NewsBannerUisngNewestNewsProps) => {
    const { data } = useGetMostNewedNewsQuery({
        type: 'articles'
    })

    return (
        <div className='news__banner'>
            {!data?.length ? (
                <div>Loading...</div>
            ) : data[0] ? (
                <>
                    <Link
                        href={`/news/${data[0].translit}`}
                        className='news__banner-main'
                    >
                        <div className='news__banner-main-img-wrapper'>
                            <div className='news__banner-main-img'>
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${data[0]?.intro}`}
                                    // width={639}
                                    // height={324}
                                    fill
                                    alt='banner-image'
                                />
                            </div>
                        </div>
                        <div className='news__banner-main-text'>
                            <ul className='news__tags'>
                                {data[0]?.tags_id
                                    .filter(tag => tag.id < 7)
                                    ?.map(tag => (
                                        <li
                                            key={tag.title}
                                            className={'news__tag'}
                                        >
                                            {tag.title}
                                        </li>
                                    ))}
                                <li className={classNames('news__tag-date', lightTheme ? s.dateColor : '')}>
                                    {/* {data[0]?.creation_date.split("T")[0].split("-")[2]}.{data[0]?.creation_date.split("T")[0].split("-")[1]}.{data[0]?.creation_date.split("T")[0].split("-")[0]} */}
                                    <NewsDate date={data[0].creation_date} />
                                </li>
                            </ul>
                            <Link
                                className={classNames('news__banner-main-title-link')}
                                href={`/news/${data[0].translit}`}
                            >
                                <h1 className={classNames('news__banner-main-title', lightTheme ? s.titleColor : '')}>
                                    {data[0]?.title}
                                </h1>
                            </Link>
                            <p
                                // dangerouslySetInnerHTML={{ __html: data[0]?.description }}
                                className={classNames('news__description', lightTheme ? s.titleColor : '')}
                            >
                                {data[0]?.subtitle}
                            </p>
                            {/* <div className='stats'>
                                <div>
                                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 17C14.6823 17 18.0156 14.8326 21 10.5C18.0146 6.16736 14.6823 4 11 4C7.31769 4 3.98435 6.16632 1 10.5C3.98538 14.8326 7.31769 17 11 17Z" stroke="#C1CCE2" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="11" cy="10" r="3.2" stroke="#C1CCE2" strokeWidth="1.6" />
                                    </svg>
                                    <p>{data[0].views}</p>
                                </div>
                                <div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.75 10.25L10 17.5L17.25 10.25C18.7688 8.73122 18.7688 6.26878 17.25 4.75C15.7312 3.23122 13.2688 3.23122 11.75 4.75L10 6.5L8.25 4.75C6.73122 3.23122 4.26878 3.23122 2.75 4.75C1.23122 6.26878 1.23121 8.73121 2.75 10.25Z" stroke="#C1CCE2" strokeWidth="1.6" />
                                    </svg>
                                    <p>17</p>
                                </div>
                                <div>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 5.06897C4 4.52024 4.24082 3.99399 4.66947 3.60599C5.09812 3.21798 5.67951 3 6.28571 3H13.7143C14.3205 3 14.9019 3.21798 15.3305 3.60599C15.7592 3.99399 16 4.52024 16 5.06897V18L10 13.3448L4 18V5.06897Z" stroke="#C1CCE2" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <p>17</p>
                                </div>
                            </div> */}
                            <StatsComponent
                                likes={data[0]?.likes}
                                views={data[0]?.views}
                                // color={lightTheme ? '#c1cce2' : ''}
                                lightTheme={lightTheme}
                            />
                        </div>
                    </Link>
                    {data.length ? (
                        <ul className='news__banner-side-list'>
                            {data.slice(1, 6)?.map(item => (
                                <NewsSideItem
                                    key={item.id}
                                    item={item}
                                    lightTheme={lightTheme}
                                />
                            ))}
                        </ul>
                    ) : null}
                </>
            ) : null}
        </div>
    )
}

export default NewsBannerUisngNewestNews
